module.exports = __webpack_public_path__ + "img/classroom.38586968.png";